







































import {Component, Mixins} from 'vue-property-decorator';
import {ResponsiveMixin} from '@/mixins/ResponsiveMixin';
import CountItemPayload from '@/models/payloads/CountItemPayload';
import CountItem from '@/models/CountItem';
import CountItemResponse from '@/models/responses/CountItemResponse';
import {findSpecie} from '@/repositories/local/CountLocal';
import {getEntities} from '@/repositories/api/CountApi';
@Component
export default class CountComponent extends Mixins(ResponsiveMixin) {
  protected loading = false;
  protected items: CountItemResponse[] = [];
  protected finder: Function = findSpecie;
  protected payload: CountItemPayload[] = [];
  protected color: string = 'primary';


  get getCountItems(): CountItem[] {
    let countItems: CountItem[] = [];

    this.items.forEach(item => {
      const specie: CountItemPayload = this.finder(item.name);
      let countItem = new CountItem();

      countItem.title = specie ? specie.label : '';
      countItem.subTitle = specie ? specie.description : '';
      countItem.icon = '';
      countItem.iconClass = '';
      countItem.value = item.count;
      countItem.color = this.color;

      countItems.push(countItem)
    });

    return countItems;
  }

  async mounted() {
    this.loading = true;

    try {
      const response = await getEntities(this.payload);
      if(response.error == 'success'){
        this.items = response.data as CountItemResponse[]
      }
    } catch (e) {
      console.log(e);
    }

    this.loading = false;
  }
}
